import { render } from "./GrigliaContabile.vue?vue&type=template&id=08487c9a"
import script from "./GrigliaContabile.vue?vue&type=script&lang=js"
export * from "./GrigliaContabile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__